export const requestErrorInterceptor = (error: unknown) => {

  return Promise.reject(error);

};
